import type { ReactElement } from 'react';
import { chunk, concat } from 'es-toolkit/compat';

export const generateRowsChunks = (
  items: ReactElement[],
  columnsCount: number,
  rows: number,
  gap: number
) => {
  if (rows <= 1) {
    return items.map((item: ReactElement, index) => ({ ...item, index }));
  }
  let index = 0;

  const chunks = chunk(items, columnsCount * rows);

  const newChunks = chunks.map((oneChunk) => {
    let chunkIndex = 0;

    const sort = Array.from<ReactElement[]>({
      length: columnsCount
    }).fill([]);

    oneChunk.forEach((item: ReactElement) => {
      const currentColumnsCount =
        oneChunk.length < columnsCount * rows
          ? Math.ceil(oneChunk.length / rows)
          : columnsCount;

      if (chunkIndex >= currentColumnsCount) {
        chunkIndex = 0;
      }

      const itemWithIndex = { ...item, index };

      const itemWithGap = {
        ...itemWithIndex,
        props: { ...item.props, style: { marginTop: gap } }
      };

      sort[chunkIndex] = [
        ...sort[chunkIndex],
        sort[chunkIndex].length > 0 ? itemWithGap : itemWithIndex
      ];

      index++;
      chunkIndex++;
    });
    return sort;
  });

  return concat(...newChunks).filter((arr) => arr.length > 0);
};
